<div class="modal fade" id="nameColorModal" tabindex="-1" aria-labelledby="nameColorModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg">
            <div class="modal-header border-bottom border-dark">
                <h5 class="modal-title text-white fw-bold" id="nameColorModalLabel">
                    <i class="bi bi-palette-fill text-info me-2"></i>Change Username Color
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body text-white">
                <!--name-color-form-->
                <div class="mb-4 text-center p-3 rounded-3 bg-black border border-secondary border-opacity-25">
                    <small class="text-muted d-block mb-1">Live Name Preview</small>
                    <span class="fs-4 fw-bold" [style.color]="selectedColor()">{{ currentUser().name }}</span>
                </div>

                <label class="form-label text-muted small fw-bold text-uppercase">Preset Colors</label>
                <div class="d-flex flex-wrap gap-2 mb-4">
                    @for (preset of presetColors; track preset.hex) {
                    <button type="button" class="btn btn-outline-dark p-2 border border-secondary border-opacity-50 d-flex align-items-center gap-2 rounded-3"
                        [class.active]="selectedColor() === preset.hex" (click)="selectPreset(preset.hex)">
                        <span class="rounded-circle d-inline-block border border-white" [style.background-color]="preset.hex" style="width: 16px; height: 16px;"></span>
                        <small class="text-white">{{ preset.name }}</small>
                    </button>
                    }
                </div>

                <div class="mb-3">
                    <label class="form-label text-muted small fw-bold text-uppercase">Custom Hex Color</label>
                    <div class="input-group">
                        <input type="color" class="form-control form-control-color bg-dark border-secondary" [ngModel]="selectedColor()" (ngModelChange)="selectedColor.set($event)" title="Choose color">
                        <input type="text" class="form-control bg-dark text-white border-secondary" [ngModel]="selectedColor()" (ngModelChange)="selectedColor.set($event)" placeholder="#9F50FF">
                    </div>
                </div>
                <!--./name-color-form-->
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" (click)="saveColor()">Save Color</button>
            </div>
        </div>
    </div>
</div>
